import Dot from '@webclient/components/search-forms/gamification-search/actions/filters/components/dot';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { setResponseLengthByUserId } from '@webclient/state/slices/app-settings';
import { selectResponseLength } from '@webclient/state/slices/app-settings/userSettingSelector';

import { ResponseLengthType } from '@webclient/shared-types/auth';

import { Text, ToggleButton } from '@knowz/knowz-ui';

export default function ResponseLengthTab() {
  const dispatch = useAppDispatch();
  const me = useAppSelector((state) => state.auth.me);
  const responseLength = useAppSelector(selectResponseLength);
  function handleChangeResponseLength(
    _: React.MouseEvent<HTMLElement>,
    value: string | null,
  ) {
    if (!me) return;
    if (value !== null) {
      dispatch(
        setResponseLengthByUserId({
          userId: me.uuid,
          responseLength: value as ResponseLengthType,
        }),
      );
    }
  }

  return (
    <ToggleButton
      fullWidth
      exclusive
      value={responseLength}
      onChange={handleChangeResponseLength}
    >
      <ToggleButton.Item
        fullWidth
        value="short"
      >
        <Text
          variant="textSm"
          weight="semibold"
        >
          <Dot visible={responseLength === 'short'} />
          &nbsp;Short
        </Text>
      </ToggleButton.Item>
      <ToggleButton.Item
        fullWidth
        value="normal"
      >
        <Text
          variant="textSm"
          weight="semibold"
        >
          <Dot visible={responseLength === 'normal'} />
          &nbsp;Normal
        </Text>
      </ToggleButton.Item>
      <ToggleButton.Item
        fullWidth
        value="detailed"
      >
        <Text
          variant="textSm"
          weight="semibold"
        >
          <Dot visible={responseLength === 'detailed'} />
          &nbsp;Detailed
        </Text>
      </ToggleButton.Item>
    </ToggleButton>
  );
}
